import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useStore } from "../context/StoreContext";

const FAQ = () => {
  const { t } = useStore();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="mx-auto max-w-6xl scroll-mt-28 px-4 py-16 sm:px-6 lg:py-24" data-testid="faq-section">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.8fr_1.2fr]">
        <h2 className="font-display text-4xl sm:text-5xl" data-testid="faq-title">{t.faq.title}</h2>
        <div className="border-t border-[var(--ink)]">
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className="border-b border-[var(--line)]" data-testid={`faq-item-${i}`}>
                <button onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-4 text-left" data-testid={`faq-toggle-${i}`} aria-expanded={isOpen}>
                  <span className="text-base font-semibold sm:text-lg">{item.q}</span>
                  <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.2 }} className="shrink-0 text-[var(--muted)]">
                    <Plus className="h-5 w-5" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }} className="overflow-hidden" data-testid={`faq-answer-${i}`}>
                      <p className="max-w-2xl pb-4 text-sm leading-relaxed text-[var(--muted)]">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
